// extracted by mini-css-extract-plugin
export default {"serviceCard":"service-card_serviceCard__VKphi","disabled":"service-card_disabled__K9kJi"};